<div class="common-modal__container-feedback">
  <!-- Cabecera -->
  <div class="common-status-message__jt-container-warning">
    <i class="lf-icon-warning-full common-status-message__icon-xl"></i>
      <span class="common-status-message__jt-title"
        [afTranslate]="'draft-evaluations.title-modal'">_Formularios guardados en modo borrador</span>
  </div>
  <!-- Contenedor -->
  <div class="common-modal__content-header-feedback-info">
    <span [afTranslate]="'draft-evaluations.info-body'">_Los siguientes formularios tienen campos obligatorios pendientes de cumplimentar. Pulsa en los enlaces para revisarlos.</span>
  </div>
  <div class="draft-evaluations__body-items">
    @for (draft of draftEvaluations.draftList; track $index) {
      <span class="common-modal__item-list-link">
        <button class="common-button__link"
          (click)="launchDraft(draft)">
          <span class="common-button__link-text">- {{draft.title}}</span>
        </button>
      </span>
    }
  </div>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text"
      (click)="handleDismiss()">
      <span class="common-button__text-title" [afTranslate]="'common.ok'">Aceptar</span>
    </button>
  </div>
</div>
